import { render, staticRenderFns } from "./UnstoppableTransferDomainOverlay.vue?vue&type=template&id=5683cb1b&scoped=true"
import script from "./UnstoppableTransferDomainOverlay.vue?vue&type=script&lang=js"
export * from "./UnstoppableTransferDomainOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683cb1b",
  null
  
)

export default component.exports